import { c as _c } from "react/compiler-runtime";
import { PaymentMethods } from 'api-graphql-types';
import { useNativePaymentMethodsContext } from '../NativePaymentMethodsContext';
import type { NativePaymentAvailable, NativePaymentMethod, PaymentMethodsOrPlaceholder } from '../types';
import { useDonationFormConfig } from '@/donationPages/_dependencies/helpers';
import type { Maybe } from '@/types';
function isNativePaymentMethod(method: PaymentMethods): method is NativePaymentMethod {
  return method === PaymentMethods.StripeApplePay || method === PaymentMethods.StripeGooglePay;
}
export function getPaymentMethodsToRender(methods: Maybe<Array<PaymentMethods>>, available: NativePaymentAvailable, loading: boolean) {
  const methodsToRender: Array<PaymentMethodsOrPlaceholder> = [];
  if (!methods?.length) return methodsToRender;
  let alreadyHasPlaceholder = false;
  for (const method of methods) {
    if (!isNativePaymentMethod(method)) {
      methodsToRender.push(method);
      continue;
    }
    if (available[method]) {
      methodsToRender.push(method);
      alreadyHasPlaceholder = true;
      continue;
    }
    if (loading && !alreadyHasPlaceholder) {
      methodsToRender.push('placeholder');
      alreadyHasPlaceholder = true;
      continue;
    }
  }
  return methodsToRender;
}
function usePaymentMethodsToRender() {
  const $ = _c(12);
  const {
    loading,
    available
  } = useNativePaymentMethodsContext();
  const {
    paymentMethods,
    recurringPaymentMethods
  } = useDonationFormConfig();
  let t0;
  if ($[0] !== available || $[1] !== loading || $[2] !== paymentMethods) {
    t0 = getPaymentMethodsToRender(paymentMethods, available, loading);
    $[0] = available;
    $[1] = loading;
    $[2] = paymentMethods;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const paymentMethodsToRender = t0;
  let t1;
  if ($[4] !== available || $[5] !== loading || $[6] !== recurringPaymentMethods) {
    t1 = getPaymentMethodsToRender(recurringPaymentMethods, available, loading);
    $[4] = available;
    $[5] = loading;
    $[6] = recurringPaymentMethods;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const recurringPaymentMethodsToRender = t1;
  let t2;
  if ($[8] !== loading || $[9] !== paymentMethodsToRender || $[10] !== recurringPaymentMethodsToRender) {
    t2 = {
      paymentMethodsToRender,
      recurringPaymentMethodsToRender,
      nativePaymentsLoading: loading
    };
    $[8] = loading;
    $[9] = paymentMethodsToRender;
    $[10] = recurringPaymentMethodsToRender;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}
export default usePaymentMethodsToRender;